var map = {
	"./decidim/avatar-multiuser.png": 7043,
	"./decidim/brands/facebook.svg": 7051,
	"./decidim/brands/google.svg": 4050,
	"./decidim/brands/twitter-x.svg": 3667,
	"./decidim/cc-badge.png": 8001,
	"./decidim/decidim-logo.svg": 1585,
	"./decidim/default-avatar.svg": 2289,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 4151,
	"./decidim/icons.svg": 5440,
	"./decidim/pattern.png": 851,
	"./decidim/placeholder-card-g.svg": 3824,
	"./decidim/placeholder-card-l.svg": 7531,
	"./decidim/placeholder.jpg": 4498,
	"./decidim/remixicon.symbol.svg": 3432,
	"./decidim/vendor/social-share-button/douban.svg": 571,
	"./decidim/vendor/social-share-button/email.svg": 2692,
	"./decidim/vendor/social-share-button/facebook.svg": 6992,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 6660,
	"./decidim/vendor/social-share-button/hacker_news.svg": 4040,
	"./decidim/vendor/social-share-button/linkedin.svg": 4034,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 3259,
	"./decidim/vendor/social-share-button/pinterest.svg": 4882,
	"./decidim/vendor/social-share-button/reddit.svg": 4952,
	"./decidim/vendor/social-share-button/telegram.svg": 3389,
	"./decidim/vendor/social-share-button/tumblr.svg": 6138,
	"./decidim/vendor/social-share-button/twitter.svg": 4337,
	"./decidim/vendor/social-share-button/vkontakte.svg": 699,
	"./decidim/vendor/social-share-button/wechat.svg": 1142,
	"./decidim/vendor/social-share-button/whatsapp.svg": 6670,
	"./decidim/vendor/social-share-button/x.svg": 5884,
	"./decidim/vendor/social-share-button/xing.svg": 8012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 632;